import anime from '../libs/anime'
import globalVar from '../utils/globalVar'

class ModuleFramework {
  constructor() {
    let cache = {};
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      cache.title = document.querySelectorAll('.module-framework .framework_title');
    };

    let registerEvents = () => {
        for (let i = 0; i < cache.title.length; i++) {
          cache.title[i].addEventListener('click',switchContent);
        }
    };

    let switchContent = function() {
       const parent = this.closest('.module-framework');
       const content = parent.querySelectorAll('.framework_content');
       const curentItem = parent.querySelector('.framework_title.active');
       const currentIndex = parseInt(curentItem.dataset.index);
       const currentContent = content[currentIndex];

       const targetCard = this;
       const targetIndex = parseInt(targetCard.dataset.index);
       const targetContent = content[targetIndex];

       curentItem.classList.remove('active');
       targetCard.classList.add('active');

       targetContent.style.display = "block";
       targetContent.style.height = "auto";
       const height = targetContent.offsetHeight;
       targetContent.style.height = 0;

       anime({
            targets: currentContent,
            duration: 400,
            opacity: [1, 0],
            height: [currentContent.offsetHeight, 0],
            easing: 'easeInOutCubic',
            complete: function() {
                currentContent.style.display = "none";
                anime({
                    targets: targetContent,
                    duration: 400,
                    opacity: [0,1],
                    height: [0, height],
                    easing: 'easeInOutCubic',
                });
            }
        });

    }

    initFunc();
  };
}
export { ModuleFramework }